import { LazyLoadImage } from 'react-lazy-load-image-component';
import styled from 'styled-components';

import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const WrapperPromotionalCard = styled.div`
    width: 316px;
    height: 400px;
    flex-direction: column;
    flex-wrap: nowrap;
    border-radius: ${BorderRadius.OuterBlockRadius};
    background-color: ${({ theme }) => theme.bgColor};
    margin: 0;

    &:hover {
        box-shadow: 0 4px 24px rgba(0, 0, 0, .08);
    }

    @media (max-width: 350px) {
        width: 288px;
    }
`;

export const ImageWrap = styled.div`
    position: relative;
    width: 100%;
    height: 148px;
    margin-bottom: 16px;

    @media (max-width: 350px) {
        height: 135px;
    }
`;

export const HeaderImage = styled(LazyLoadImage)`
    width: 100%;
    height: 100%;
    border-radius: ${BorderRadius.OuterBlockRadius} ${BorderRadius.OuterBlockRadius} 0 0;
`;

export const BodyCard = styled.div`
    padding: 0 24px;
    gap: 6px;

    @media (max-width: 350px) {
        padding: 0 10px;
    }
`;

export const ButtonBlock = styled.div`
    width: 100%;
    padding: 0 24px 24px 24px;
    flex-direction: column;
    justify-content: flex-end;

    @media (max-width: 350px) {
        padding: 0 10px 10px 10px;
    }
`;

export const LabelsBlock = styled.div`
    width: 100%;
    flex-direction: row;
    gap: 8px;
`;

export const Container = styled.div`
    gap: 14px;
    flex-grow: 1;
`;

export const Title = styled.div`
    display: -webkit-box;
    width: 268px;
    max-height: 2.8em;
    ${({ theme }) => theme.titleFont};
    color: ${({ theme }) => theme.titleColor};
    overflow-wrap: anywhere;
    overflow: hidden;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
`;

export const Description = styled(Title)`
    ${({ theme }) => theme.descriptionFont};
    color: ${({ theme }) => theme.descriptionColor};
    max-height: 4.6em;
    -webkit-line-clamp: 3;
`;

export const Button = styled(BaseButton)`
    position: relative;
    width: 100%;
    ${({ theme }) => theme.buttonFont};
`;

export const TextLabel = styled.div`
    ${FONTS.LABEL};
    color: ${COLORS.LabelsText_2};
    align-items: center;
`;
